module.exports = __webpack_public_path__ + "img/Slice1@2x.144c25de.png";